import React, { useRef } from 'react';

interface SidePopUpProps {
	isRight: boolean;
	children?: React.ReactNode;
	isOpen: boolean;
	onClose: () => void;
	sidePanelClassName?: string;
}
const SidePopup: React.FC<SidePopUpProps> = (props) => {
	const overlayRef = useRef(null);
	const handleOverlayClick = (e: React.MouseEvent<HTMLElement>) => {
		if (e.target == overlayRef.current) {
			props.onClose();
		}
	};
	return (
		<>
			<div
				ref={overlayRef}
				className={`transition-opacity duration-1000 fixed ${props.isOpen ? 'w-full h-full bg-opacity-30' : 'w-0 h-0 bg-opacity-0'} top-0 left-0 bg-gray-900 z-30 ease-in-out `}
				onClick={handleOverlayClick}
			></div>
			<div
				className={`fixed top-0 
				${props.isRight ? 'right-0 rounded-tl-3xl rounded-bl-3xl' : 'left-0 rounded-tr-3xl rounded-br-3xl'}
				 w-[80vw] md:w-[50vw] lg:w-[30vw] bg-white h-full overflow-auto z-50 
				 transition-transform ${props.isOpen ? 'translate-x-0' : `${props.isRight ? 'translate-x-full' : 'translate-x-[-100%]'}`} ease-out duration-300
				 ${props.sidePanelClassName ? props.sidePanelClassName : ''}`}
			>
				{props.children}
			</div>
		</>
	);
};

export default SidePopup;
